<template>
  <div class="info-push" v-if="unreadMsg">
    <div class="inside-box" @click="updateRead('a')">
      <p v-for="(item,i) in allUnreadMessage" :key="i">
        {{item.content}}
      </p>
    </div>
    <i class="close-icon el-icon-close" @click="updateRead('b')"></i>
  </div>
</template>
<script>
import { subscribePushmsg, subscribeManagement } from '@/views/clue/api/subscribeApi'
export default {
  data() {
    return {
      unreadMessage: [],
      allUnreadMessage: [],//所有未读信息
      pushTimeArr: [],//订阅推送时间数组
      timerA: null,
      unreadMsg: false,
      flag: 0,
    }
  },
  created() {
  },
  beforeDestroy() {
    clearInterval(this.timerA)
    this.timerA = null
  },
  destroyed() {
    clearInterval(this.timerA)
    this.timerA = null
  },
  mounted() {
    this.getsubscribePushmsg()
    this.getSubscribeManagement()
    //    this.getNowTimes()
  },
  methods: {
    // 获取订阅组时间
    getSubscribeManagement() {
      subscribeManagement().then(res => {
        if (res.code == 200) {
          if (res.data) {
            res.data.forEach(v => {
              this.pushTimeArr.push({
                dateType: v.dateType,
                hour: v.hour,
                week: v.week,
                minT: v.hour.split(':')
              })
            })
            this.pushTimeArr.forEach(vv => {
              vv.minStr = parseInt(vv.minT[0] * 60) + parseInt(vv.minT[1])
            })
            this.getNowTimes()
          }
        }
      })
    },
    getNowTimes() {
      this.timerA = window.setInterval(() => {
        setTimeout(() => {
          //获取当前时间
          let myDate = new Date()
          let wk = myDate.getDay()
          let yy = String(myDate.getFullYear())
          let mm = myDate.getMonth() + 1
          let dd = String(myDate.getDate() < 10 ? '0' + myDate.getDate() : myDate.getDate())
          let hou = String(myDate.getHours() < 10 ? '0' + myDate.getHours() : myDate.getHours())
          let min = String(myDate.getMinutes() < 10 ? '0' + myDate.getMinutes() : myDate.getMinutes())
          let sec = String(myDate.getSeconds() < 10 ? '0' + myDate.getSeconds() : myDate.getSeconds())
          let weeks = [7, 1, 2, 3, 4, 5, 6]
          let week = weeks[wk]


          let nowMin = parseInt(hou * 60) + parseInt(min)
          this.pushTimeArr.forEach(item => {
            // console.log('chaMin',nowMin,item.minStr,nowMin - item.minStr)
            if (Math.abs(nowMin - item.minStr) < 3) {
              if (item.dateType == 1) {
                this.getsubscribePushmsg()
              } else if (item.dateType == 2) {
                if (week == item.week) {
                  this.getsubscribePushmsg()
                }
              }
            } else {
              // clearInterval(this.timerA)
              // this.timerA = null
            }
          })
        }, 0);
      }, 60000)
      this.$on('hook:beforeDestroy', () => {
        clearInterval(this.timerA)
        this.timerA = null
      })


    },
    getsubscribePushmsg() {
      subscribePushmsg().then(res => {
        if (res.code == 200) {
          if (res.data.length) {
            this.unreadMessage = res.data
            this.allUnreadMessage = this.allUnreadMessage.concat(this.unreadMessage)
            this.unreadMsg = true
            this.flag = this.flag + 1
          }
          // console.log('消息',this.flag +'次数' + this.allUnreadMessage)
        }
      })
    },
    updateRead(val) {
      this.unreadMsg = false
      if (val == 'a') {
        this.$router.push('/zxk/junbros/subscribeList')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.info-push {
  position: absolute;
  width: 539px;
  box-sizing: border-box;
  z-index: 12;
  // top: 0;
  right: 24px;
  bottom: 0;
  background: #ffffff;
  box-shadow: -4px 0px 11px 0px rgba(0, 0, 0, 0.1);
  border-radius: 4px 0px 0px 4px;
  cursor: pointer;
  .inside-box {
    margin: 9px 0 14px;
    padding: 0 24px;
    box-sizing: border-box;
  }
  p {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    box-sizing: border-box;
    font-weight: 400;
    color: #333333;
    font-size: 13px;
    line-height: 18px;
    border-bottom: 1px solid rgba(187, 190, 202, 0.2);
    padding-top: 16px;
    padding-bottom: 10px;
    &:nth-last-of-type(1) {
      border-bottom: none;
    }
  }
  .close-icon {
    position: absolute;
    right: 7px;
    top: 13px;
    cursor: pointer;
    &:before {
      font-size: 20px;
    }
  }
}
</style>